import PropTypes from "prop-types";
import { checkinFacts } from "./lib/history";

/**
 * A session's check-in, read back (walkthrough 2's answers): sleep,
 * energy, motivation and stress with their scale's ends, soreness per
 * region, and joint pain. A question left unanswered says so — the engine
 * held on it (D12). No check-in at all: it was skipped.
 */
function CheckinSummary({ checkin }) {
  if (!checkin) {
    return (
      <p className="m-0 text-sm text-muted-foreground">
        Skipped — no check-in, so how you felt didn&apos;t change this session&apos;s plan.
      </p>
    );
  }
  return (
    <dl className="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
      {checkinFacts(checkin).map((fact) => (
        <div key={fact.key} className="contents">
          <dt className="font-medium">{fact.label}</dt>
          <dd className="m-0 tabular-nums">
            {fact.value === null ? (
              <span className="text-muted-foreground">not answered</span>
            ) : (
              <>
                {fact.value}
                {fact.scale && (
                  <>
                    {" "}
                    <span className="text-muted-foreground">({fact.scale})</span>
                  </>
                )}
              </>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}

CheckinSummary.propTypes = {
  /** The session's TrainingCheckin, or null when it was skipped. */
  checkin: PropTypes.shape({
    sleep: PropTypes.number,
    energy: PropTypes.number,
    motivation: PropTypes.number,
    stress: PropTypes.number,
    soreness: PropTypes.object,
    joint_pain: PropTypes.arrayOf(PropTypes.object),
  }),
};

export default CheckinSummary;
